export default __webpack_public_path__ + "static/maria-0f36b2e3c27abbda067d60c378882f0e.png";